/*
* Takes an object's field (typically from API2) of camelCase format or snake_format
* and return a space delimited string such as `camel Case` or `snake format`
* for readability in headers/titles where the backing object's schema isn't known
* ahead of time
*/
const formatObjectField = field => {
  if (field.includes('_')) {
    return field.split('_').join(' ');
  } else {
    return field.replace(/([A-Z])/g, ' $1');
  }
};

export default formatObjectField;
